import React, { useState, useEffect, useMemo }  from 'react';
import { compose, } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import {
  InfoBoxWrapper, MapControl,
  MapControlButton, MapControlSelection, MapDrawing
} from 'components/map';
import {
  MarkerWrapper
} from 'components/underwrite/shared/map';
import debounce from 'lodash/debounce';
// Marker clusterer images
import { 
  setAuctionUWMapState, setAuctionUWMarkerState,
} from 'store/actions';
import {
  selectedAuctionTxnOppsSelector
} from 'store/selectors';
import ImageSearchIcon from '@material-ui/icons/ImageSearch';
import GestureIcon from '@material-ui/icons/Gesture';
import MapIcon from '@material-ui/icons/Map';
import TerrainIcon from '@material-ui/icons/Terrain';
import ZoomOutMapIcon from '@material-ui/icons/ZoomOutMap';


const AuctionUWMap = ({ 
  map, selectedAuctionTxnOpps, viewValuationDialogIsOpen, autoNav, selectedMarker,
  selectedMarkerLabel, isUserOwnedTask, isInfoBoxOpen, setAuctionUWMarkerState, classes,
  setAuctionUWMapState, gestureHandling, mapViewType, auctionGridCurrentViewData, auctionUWMapState,
  auctionUWMarkerState, isDrawing, polygon, isStreetView
}) => {
  const [allowDrawing, setAllowDrawing] = useState(true);
  const [onMount, setOnMount] = useState(true);

  useEffect(() => {
    if (!onMount) {
      setDefaultBounds();
      map.getStreetView().setVisible(false);
      // if the draw tool is on, turning it off on transition
      if (isDrawing) {
        setAuctionUWMapState({ isDrawing: false });
      }
      setUncapturedMarkers([]);
    }
  }, [selectedAuctionTxnOpps.map(o => o.id).toString()]);

  // If auto nav effect, navgiates to selected marker
  useEffect(() => {
    if (!viewValuationDialogIsOpen && autoNav && selectedMarker && selectedAuctionTxnOpps?.length > 0) {
      const selectedOpp = selectedAuctionTxnOpps.find((el) => el.id === selectedMarker.id);
      if (selectedOpp.latitude && selectedOpp.longitude) {
        map.panTo(new window.google.maps.LatLng(selectedOpp.latitude, selectedOpp.longitude));
      }
    }
  }, [selectedMarker]);

  useEffect(() => {
    if (!auctionUWMapState.initialized) {
      setDefaultBounds();
      map.getStreetView().setVisible(false);
      setAuctionUWMapState({ initialized: true });
    }
    if (onMount) {
      setOnMount(false);//used for skipping first useEffect when navigating back to map
    }
  }, []);

  const onMarkerClusterClick = markerCluster => markerCluster.getMap().fitBounds(markerCluster.getBounds());

  const onClusteringBegin = debounce(clusterer => {
    if (map.getZoom() < 10 && selectedMarker) {
      //keep selection on selected marker if it is not part of any cluster
      let isSelectedMarkerInCluster = clusterer.getClusters().filter(c => c.getMarkers().length > 1 && c.getMarkers().filter(m => selectedMarker && m.labelContent.children[0].dataset.id === selectedMarker.id.toString()).length > 0).length > 0;
      if (isSelectedMarkerInCluster) {
        setAuctionUWMarkerState({
          isInfoBoxOpen: false, 
          selectedMarker: null,
          isFetchingImages: false,
          selectedMarkerImages: [],
        });
      }
    }
    if (map.getZoom() < 10) {
      if (allowDrawing) {
        let clustersExists = clusterer.getClusters().filter(c => c.getMarkers().length > 1).length > 0;
        if (clustersExists) {
          setAllowDrawing(false);
          setUncapturedMarkers([]);
          setAuctionUWMapState({ isDrawing: false });
        }
      }
    } else if (!allowDrawing) {
      setAllowDrawing(true);
    }
  }, 300);

  const rentLabelOptions = [
    { value: '', label: '' },
    { value: 'yearBuilt', label: 'Year Built' },
    { value: 'beds', label: 'Beds' },
    { value: 'baths', label: 'Baths' },
    { value: 'sqft', label: 'Sqft' },
    { value: 'ctMedIncome', label: 'CT Med Income' },
    { value: 'schoolScore', label: 'School Score' },
    { value: 'region', label: 'Region' },
  ];
  // const saleSoldLabelOptions = [
  //   { value: '', label: '' },
  //   { value: 'yearBuilt', label: 'Year Built' },
  //   { value: 'beds', label: 'Beds' },
  //   { value: 'baths', label: 'Baths' },
  //   { value: 'sqft', label: 'Sqft' },
  //   { value: 'rentprice', label: 'Price' },
  //   { value: 'rentpricesqft', label: 'Price/Sqft' }
  // ];

  const setDefaultBounds = () => {
    if (selectedAuctionTxnOpps) {
      const bounds = new window.google.maps.LatLngBounds();
      selectedAuctionTxnOpps.forEach(bound => {
        if (bound.latitude && bound.longitude) {
          let position = new window.google.maps.LatLng(bound.latitude, bound.longitude);
          bounds.extend(position);
        }
      });
      map.fitBounds(bounds, 50);     // This should set the zoom level to ensure all markers are inside the viewport
    }
  }
  
  const toggleDrawIsOn = () => {
    setUncapturedMarkers([]);
    setAuctionUWMapState({ isDrawing: !isDrawing });
  }

  const toggleGestureHandling = () => {
    let newGestureHandling = gestureHandling === 'cooperative' ? 'auto' : 'cooperative';
    setAuctionUWMapState({ gestureHandling: newGestureHandling });
    map.setOptions({ gestureHandling: newGestureHandling });
  }

  const toggleMapViewType = () => {
    let newMapViewType = mapViewType === 'roadmap' ? 'hybrid' : 'roadmap';
    setAuctionUWMapState({ mapViewType: newMapViewType });
    map.setOptions({ mapTypeId: newMapViewType });
  }

  const toggleAutoNav = () => {
    setAuctionUWMapState({ autoNav: !autoNav });
  }
  
  const setUncapturedMarkers = markersOutside => {
    setAuctionUWMarkerState({ uncapturedMarkers: markersOutside });
  }
  const setSelectedMarker = marker => {
    setAuctionUWMarkerState({ isInfoBoxOpen: true, isFetchingImages: true, selectedMarkerImages: [], selectedMarker: marker });
  }

  const setSelectedMarkerLabel = e => {
    setAuctionUWMapState({ selectedMarkerLabel: e.target.value });
  }

  let markers = useMemo(() => 
    selectedAuctionTxnOpps.map(marker => (
      <MarkerWrapper
        key={marker.id}
        marker={marker}
        txnOpp={marker}
        map={map}
        selectedMarker={selectedMarker}
        setSelectedMarker={setSelectedMarker}
        selectedMarkerLabel={selectedMarkerLabel}
        autoNav={autoNav}
        uwType={'auctionUW'}
        iconColor={'orange'}
        iconType={"house"}
        gridCurrentViewData={auctionGridCurrentViewData}
        isUserOwnedTask={isUserOwnedTask}
        isCaptured={!auctionUWMarkerState.uncapturedMarkers.includes(marker.id)}
        isStreetView={isStreetView}
      />
    )), [selectedMarker, selectedMarkerLabel, isStreetView, autoNav, JSON.stringify(auctionGridCurrentViewData), isUserOwnedTask, JSON.stringify(selectedAuctionTxnOpps), auctionUWMarkerState.uncapturedMarkers]);

  return (
    // const strategyTypes = [{
    //   type: 'Fairway',
    //   color: '#89da89'
    // }, {
    //   type: 'Downstream',
    //   color: '#ffff92',
    // }, {
    //   type: 'Violates',
    //   color: '#ff6e6e'
    // }, {
    //   type: 'Unknown',
    //   color: '#b3b3b3'
    // }];
    <>
      <>
        {/* <MarkerClusterer
          onClick={onMarkerClusterClick}
          onClusteringBegin={onClusteringBegin}
          averageCenter
          enableRetinaIcons
          gridSize={60}
          zoomOnClick={false}
          maxZoom={9}
          styles={clusterStyles}
        > */} {/* Commented out because cluster need to be fully working with drawing, and need to fix bug about row selecting when clustering occurs*/}
          {markers}
        {/* </MarkerClusterer> */}
        <MapControl map={map} position={window.google.maps.ControlPosition.TOP_RIGHT} className='mapControlMargin'>
          <div className={classes.controlContainer}>
            <MapControlSelection title='LABEL' id='label' value={selectedMarkerLabel}
              onChange={setSelectedMarkerLabel}
              options={rentLabelOptions} />
            {allowDrawing && <MapControlButton title='Draw shape' active={isDrawing} onClick={toggleDrawIsOn}><GestureIcon className={classes.mapIcon}/></MapControlButton>}
            <MapControlButton title='Auto Navigate' active={autoNav} onClick={toggleAutoNav}><ImageSearchIcon className={classes.mapIcon}/></MapControlButton>
            <MapControlButton title='Toggle map view' onClick={toggleMapViewType}>{mapViewType === 'roadmap' ? <TerrainIcon className={classes.mapIcon}/> : <MapIcon className={classes.mapIcon}/>}</MapControlButton>
            <MapControlButton title='Toggle scroll zoom' onClick={toggleGestureHandling} active={gestureHandling === 'auto'}><ZoomOutMapIcon className={classes.mapIcon}/></MapControlButton>
          </div>
        </MapControl>
        {/* <MapControl map={map} position={window.google.maps.ControlPosition.TOP_LEFT} className='mapControlMargin'>
          <div className={classes.controlContainer}>
            <MapLegend types={strategyTypes} />
          </div>
        </MapControl> */}
        <MapDrawing
          map={map}
          drawIsOn={isDrawing}
          selectedOpportunityComps={selectedAuctionTxnOpps}
          setUncapturedMarkers={setUncapturedMarkers}
          uwType={'auctionUW'}
          polygon={polygon}
          setMapState={setAuctionUWMapState}
        />
      </>
      {selectedMarker && isInfoBoxOpen &&
        <InfoBoxWrapper
          markerState={auctionUWMarkerState}
          setMarkerState={setAuctionUWMarkerState}
        />
      }
    </>
  );
};
const styles = theme => ({
  controlContainer: {
    display: 'flex',
    //background: theme.palette.background.default,
  },
  toggle: {
    border: '1px solid #bfbfbf',
  },
  mapIcon: {
    fontSize: '1rem'
  }
});

const mapStateToProps = (state) => {
  return {
    auctionUWMapState: state.auctionUWState.auctionUWMapState,
    gestureHandling: state.auctionUWState.auctionUWMapState.gestureHandling,
    mapViewType: state.auctionUWState.auctionUWMapState.mapViewType,
    autoNav: state.auctionUWState.auctionUWMapState.autoNav,
    selectedMarkerLabel: state.auctionUWState.auctionUWMapState.selectedMarkerLabel,
    polygon: state.auctionUWState.auctionUWMapState.polygon,
    auctionUWMarkerState: state.auctionUWState.auctionUWMarkerState,
    selectedMarker: state.auctionUWState.auctionUWMarkerState.selectedMarker,
    isInfoBoxOpen: state.auctionUWState.auctionUWMarkerState.isInfoBoxOpen,
    isFetchingImages: state.auctionUWState.auctionUWMarkerState.isFetchingImages,
    selectedMarkerImages: state.auctionUWState.auctionUWMarkerState.selectedMarkerImages,
    viewValuationDialogIsOpen: state.auctionUWState.viewValuationDialogIsOpen,
    selectedAuctionTxnOpps: selectedAuctionTxnOppsSelector(state),
    auctionGridCurrentViewData: state.auctionUWState.auctionGridCurrentViewData,
    isDrawing: state.auctionUWState.auctionUWMapState.isDrawing
  }
};

const mapDispatchToProps = (dispatch) => ({
  setAuctionUWMapState: auctionUWMapState => dispatch(setAuctionUWMapState(auctionUWMapState)),
  setAuctionUWMarkerState: auctionUWMarkerState => dispatch(setAuctionUWMarkerState(auctionUWMarkerState)),
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(AuctionUWMap);